import { Department } from "../../../features/Admin/Departments/departments.component";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";
import { useTranslation } from "react-i18next";
import { getOrgBackend } from "../../../app/backend";

export function useRemoteGetMutateAllCostCentersForCompany(companyId?: number) {
  const { t } = useTranslation();

  return useRemoteMutation<Department[], RemoteApiError, void>({
    key: ["costCenters", companyId],
    url: `${getOrgBackend()}/erp/companies/${companyId}/costcenters`,
    method: "get",
    snackbarTextOnFail: t("There was a server error")
  });
}
